module.exports = __webpack_public_path__ + "assets/3a791e35ccd616882dcc3d414f6e15b7.png";